import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import HistoryReturnButton from '@/components/history-return-button'
import DisposalTrendWrapperPublic from '@/components/disposal-trend/wrapper-public'
import CollectionPointDetailWrapperPublic from '@/components/collection-point/detail/wrapper-public'

function DisposalTrendPublicView() {

    const collectionPointIdContent = document.getElementById('household-id')?.innerHTML
    const collectionPointId = collectionPointIdContent ? Number.parseInt(collectionPointIdContent) : 0

    const collectionPointCodeContent = document.getElementById('household-code')?.innerHTML
    const collectionPointCode = collectionPointCodeContent ? collectionPointCodeContent : 'UNKNOWN'

    const numberOfMembersContent = document.getElementById('number-of-members')?.innerHTML
    const numberOfMembers = numberOfMembersContent ? Number.parseInt(numberOfMembersContent) : 1

    const binWeightings365DaysContent = document.getElementById('bin-weightings-365-days')?.innerHTML
    const binWeightings365Days = binWeightings365DaysContent ? JSON.parse(binWeightings365DaysContent) : []

    const binWeightingsThisYearContent = document.getElementById('bin-weightings-this-year')?.innerHTML
    const binWeightingsThisYear = binWeightingsThisYearContent ? JSON.parse(binWeightingsThisYearContent) : []

    const binWeightingsLastYearContent = document.getElementById('bin-weightings-last-year')?.innerHTML
    const binWeightingsLastYear = binWeightingsLastYearContent ? JSON.parse(binWeightingsLastYearContent) : []

    const collectionCalendarContent = document.getElementById('collection-calendar-this-year')?.innerHTML
    const collectionCalendar = collectionCalendarContent ? JSON.parse(collectionCalendarContent) : []

    const singleHouseholdContent = document.getElementById('single-household')?.innerHTML
    const singleHousehold = singleHouseholdContent ? JSON.parse(singleHouseholdContent) : []

    const discountForSortingContent = document.getElementById('discount-for-sorting')?.innerHTML
    const discountForSorting = discountForSortingContent ? JSON.parse(discountForSortingContent) : {}

    const discountForVolumeContent = document.getElementById('discount-for-volume')?.innerHTML
    const discountForVolume = discountForVolumeContent ? JSON.parse(discountForVolumeContent) : {}

    const discountForBioSortingContent = document.getElementById('discount-for-bio-sorting')?.innerHTML
    const discountForBioSorting = discountForBioSortingContent ? JSON.parse(discountForBioSortingContent) : {}

    const title = 'Detail svozového místa: '+collectionPointCode
    const titleTrend = 'Trend výsypu svozového místa: '+collectionPointCode

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box>
                    <HistoryReturnButton />
                </Box>
                <Typography variant="h2" component="h1" mb={3}>
                    {title}
                </Typography>
                {collectionPointId ?
                    <>
                        <CollectionPointDetailWrapperPublic
                            singleHousehold={singleHousehold}
                            discountForSorting={discountForSorting}
                            discountForVolume={discountForVolume}
                            discountForBio={discountForBioSorting}
                            collectionCalendar={collectionCalendar}
                        />
                        <Typography variant="h2" component="h1" mt={10}>
                            {titleTrend}
                        </Typography>
                        <DisposalTrendWrapperPublic
                            numberOfMembers={numberOfMembers}
                            binWeightings365Days={binWeightings365Days}
                            binWeightingsThisYear={binWeightingsThisYear}
                            binWeightingsLastYear={binWeightingsLastYear}
                            collectionCalendar={collectionCalendar}
                        />
                    </>
                    :
                    <Box>
                        Tento odkaz pro zobrazení trendu výsypu svozového místa již nefunguje.
                    </Box>
                }
            </CustomPaper>
        </>
    )
}

export default DisposalTrendPublicView
